module.exports = __webpack_public_path__ + "4f90a60791f24a46f2c1c3ca21f5fc88.svg";